import React, { JSX } from 'react';
import PageError from 'components/PageError';
import { useTranslation } from 'react-i18next';
import Button, { ButtonVariant } from 'components/Button';

interface Props {
  eventId: string;
}

export default function ErrorBoundary({ eventId }: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <PageError
      title={t('error-occured', 'Error occurred')}
      text={t(
        'something-went-wrong-informed',
        'Something went wrong. Our team has been informed and is trying to fix it as soon as possible.',
      )}
      eventId={eventId}
    >
      <Button
        variant={ButtonVariant.Primary}
        onClick={() => {
          window.location.href = '/';
        }}
      >
        {t('back', 'Back')}
      </Button>
    </PageError>
  );
}
